import React, { useState, useEffect, useContext } from 'react'
import { officeIds, IProps, IDepartment, IOffice, IJob } from './index'
import { Jobs } from './jobs'
import { CareersLocationContext } from 'marketing-site/lib/page-behaviors/CareersLocation'
import flattenOfficeData from './helpers/flattenOfficeData'

export const GreenhouseListings = ({
  title,
  data,
  noResults,
  roleFilter,
  orgFilter,
  ghSrcToken,
}: IProps): React.ReactElement | null => {
  const { location } = useContext(CareersLocationContext)
  const [officeData, setOfficeData] = useState<IDepartment[] | undefined>()
  const officeId = location ? officeIds[location] : undefined

  useEffect(() => {
    const office: IOffice | undefined = data.offices.find(
      (office: IOffice) => office.id === officeId,
    )
    const departments = office ? office.departments : flattenOfficeData(data)
    const filteredDeparments = filterDepartments(departments, roleFilter, orgFilter)
    const traceableDeparmentJobs = appendTokenToJobPosts(filteredDeparments, ghSrcToken)
    setOfficeData(traceableDeparmentJobs)
  }, [officeId, data, roleFilter, orgFilter, ghSrcToken])

  if (!officeData) return null

  return (
    <Jobs
      officeData={officeData}
      title={title}
      noResults={noResults}
      officeId={officeId}
      showTeamPageCTA={!roleFilter && !orgFilter}
    />
  )
}

const filterDepartments = (
  data: IDepartment[],
  roleFilterTerm?: string,
  orgFilterTerm?: string,
): IDepartment[] => {
  const departmentsInOrg = orgFilterTerm
    ? data.filter((d) => d.name.match(new RegExp(orgFilterTerm, 'ig')))
    : data

  const departmentsWithRole = roleFilterTerm
    ? departmentsInOrg.map((department: IDepartment) => {
        const jobs = department.jobs.filter((job) =>
          job.title.match(new RegExp(roleFilterTerm, 'ig')),
        )
        return { ...department, jobs }
      })
    : departmentsInOrg

  const departmentsWithJobs = departmentsWithRole.filter((department) => department.jobs.length > 0)

  return departmentsWithJobs
}

const appendTokenToJobPosts = (departments: IDepartment[], token?: string): IDepartment[] => {
  if (!token) return departments

  return departments.map((d) => ({
    ...d,
    jobs: d.jobs.map((job: IJob) => {
      /* eslint-disable @typescript-eslint/naming-convention */
      return { ...job, absolute_url: job.absolute_url + `?gh_src=${token}` }
    }),
  }))
}
